<template>
  <!-- Element Plus 弹窗 -->
  <div>
    <el-dialog
      v-model="dialogVisible"
      :width="modalWidth"
      :append-to-body="false"
      class="custom-area-dialog"
      :show-close="false"
      :style="{ maxWidth: '1200px', width: '90%', background: '#252C3D' }"
      @close="dialogVisible = false"
    >
      <div class="custom-wrapper">
        <!--头部-->
        <div class="header flex justify-between align-center">
          <div class="cumtom-title">{{isShowCityOrPrivice==1?t('weather.selectCity'):t('weather.selectArea')}}</div>
          <el-icon @click="dialogVisible = false"><CloseBold /></el-icon>
        </div>

        <!-- 搜索框 -->
        <div class="custom-search flex items-center">
          <el-select
            v-model="searchCity"
            filterable
            remote
            :placeholder="t('weather.inputCity')"
            :remote-method="getSearchList"
          >
            <template #empty>
              <div class="city-search-empty">{{ t('common.noData') }}</div>
            </template>
              <el-option
              @click="selectArea(item.cityId,item.mId,'')"
                v-for="item in searchList"
                :key="item.cityId"
                :label="item.name"
                :value="item.cityId+'/'+item.mId"
            />
          </el-select>
          <div class="btn-default flex items-center justify-center ml-2" @click="selectArea(searchCity?.split('/')?.[0],searchCity?.split('/')?.[1],'search')">
            <el-icon><Search /></el-icon>
          </div>
        </div>

        <!-- 热门城市 -->
        <div class="hot-city mb-8" v-if="isShowCityOrPrivice==1">
          <h3 class="h3-title">{{t('weather.hotCity')}}</h3>
            <div  class="cursor-pointer custom-tag" >
                <div v-for="city in hotCity" :key="city.id">
                <nuxt-link @click="selectArea(city.id,city.mid,'')">{{ city.name }}</nuxt-link>
                </div>
            </div>
        </div>

        <!-- 全部省份（重新排版核心区域） -->
        <div class="province-section" v-if="isShowCityOrPrivice==1">
          <h3 class="h3-title">{{t('weather.allProvince')}}</h3>
          <!-- 省份首字母分组容器 -->
          <div class="province-container">
            <!-- 单个首字母分组 -->
            <div
              v-for="(provinceList, initial) in provinces"
              :key="initial"
              class="province-group flex"
            >
              <!-- 首字母标签 -->
              <div class="initial-tag flex items-center">
                <span class="initial-text">{{ initial }}</span>
              </div>
              <!-- 省份列表（自适应排版） -->
              <div class="province-list">
                <span
                  v-for="province in provinceList"
                  :key="province.id"
                  @click="selectProvince(province.id,province.name)"
                  class="province-item"
                >
                  {{ province.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--全部地区-->
        <div class="province-section" v-if="isShowCityOrPrivice==2">
          <h3 class="h3-title">{{ t('weather.country') }} {{ provinceName }} {{ t('weather.allCity') }}</h3>
          <!-- 省份首字母分组容器 -->
          <div class="province-container">
            <!-- 单个首字母分组 -->
            <div
              v-for="(cityItem, initial) in cityList"
              :key="initial"
              class="province-group flex"
            >
              <!-- 首字母标签 -->
              <div class="initial-tag flex items-center">
                <span class="initial-text">{{ initial }}</span>
              </div>
              <!-- 省份列表（自适应排版） -->
              <div class="province-list">
                <span
                  v-for="city in cityItem"
                  :key="city.id"
                  @click="selectArea(city.id,city.mid,'')"
                  class="province-item"
                >
                  {{ city.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { CloseBold, Search } from '@element-plus/icons-vue' // 显式导入图标
import useServerRequest from '@/composables/useServerRequest'
import type {ProvinceResponse,GroupedProvinces, Province,} from '~/types';
import { useI18n } from 'vue-i18n' // 导入 useI18n
const { locale,t } = useI18n() // 获取当前 i18n 语言（如 zh-CN/en-US）
const cmsurlStrategy = '/system/new/area/'
// 弹窗显隐
// 搜索词
const searchCity = ref<string>('')
// 弹窗显隐
const props = withDefaults(
  defineProps<{
    cityVisible?: boolean;
  }>(),
  {
    cityVisible: false,
  }
)

// 定义事件
const emit = defineEmits<{
  (e: 'update:cityVisible', value: boolean): void;
  (e: 'setCityId', payload: { id: number | string ,mid:number | string}): void; // 添加新事件
}>()

// 使用计算属性实现双向绑定
const dialogVisible = computed({
  get: () => props.cityVisible,
  set: (value) => emit('update:cityVisible', value)
})

// 处理关闭事件
const handleClose = () => {
  emit('update:cityVisible', false)
}

// 省份数据（按首字母分组）
const provinces = ref<GroupedProvinces>()

// 自适应宽度
const modalWidth = computed(() => 'auto')
// 选择城市
const loading = ref(false)
const searchList = ref<Province[]>([])
const getSearchList = async(query: string) =>{
  if (query) {
      loading.value = true
      const { data } = await useServerRequest('search-city-list', `${cmsurlStrategy}/citySearch`, { method: 'GET',params:{keywords:query,pageNo:1,pageSize:50}, language: 'zh-CN' })
      loading.value = false
      searchList.value = data?.value?.data || []
  } else {
    searchList.value = []
  }
}
const isShowCityOrPrivice = ref<number>(1)
const provinceName = ref<string>("");

const selectProvince = (provinceId: number, selectedName: string) => {
  // 给响应式变量赋值（用 .value）
  isShowCityOrPrivice.value = 2
  provinceName.value = selectedName || ""; 
  getCityList(provinceId);
  // 其他选中逻辑（如高亮）
};
//点就获取城市
const cityList=ref<GroupedProvinces>()
const getCityList=async (provinceId:number) => {
  
  const { data } = await useServerRequest<ProvinceResponse>('city-list', `${cmsurlStrategy}/getCityAndDistrictList`, {params:{provinceId:provinceId}, method: 'GET', language: 'zh-CN' })
  cityList.value=groupProvincesWithAllFields(data?.value?.data)
}
//获取热门城市
const hotCity=ref<any>()
const getHotCity = async () =>{
  const { data } = await useServerRequest<ProvinceResponse>('hot-city-list', `${cmsurlStrategy}/getHotCity`, { method: 'GET', language: 'zh-CN' })
    hotCity.value=data?.value?.data
}
//获取省份
const getProvincedata = async() =>{
  try {
        isShowCityOrPrivice.value=1
        const { data } = await useServerRequest<ProvinceResponse>('province-list', `${cmsurlStrategy}/getProvinceList`, { method: 'GET', language: 'zh-CN' })
        provinces.value = groupProvincesWithAllFields(data?.value?.data)
        console.log(provinces.value)
  } catch(error){
  }
}
const selectArea = (id: number | string,mid:number | string,from:string) => {
  if(from === 'search'){
    if(searchList.value.length==0){
      return false
    } else {
      emit('setCityId', {id: searchList.value[0].cityId,mid:searchList.value[0].mId});
      emit('update:cityVisible', false)
    }
  } else {
    if(!id &&  !searchCity.value) return  false
    emit('update:cityVisible', false)
    emit('setCityId', {id: id ||  searchCity?.value?.split('/')?.[0],mid:mid  ||  searchCity?.value?.split('/')?.[1]}); // 修正事件名
  }
 
  
};
// 关键：暴露方法给父组件（严格类型，需明确暴露的属性/方法）
defineExpose({
  getProvincedata,
  getHotCity
})
const groupProvincesWithAllFields = (
  rawData: Readonly<Province[]>
): GroupedProvinces => {
  const grouped: Record<string, Province[]> = {};

  // 1. 按 capitalize 分组，保留所有字段（无过滤）
  rawData.forEach(province => {
    const key = province.capitalize;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    // 保留所有字段：id、name、namePy、nameInitial、capitalize、pid、cityType、longitude、latitude
    grouped[key].push({ ...province });
  });

  // 2. 组内按拼音（namePy）升序排序
  Object.keys(grouped).forEach(key => {
    grouped[key].sort((a, b) => a.namePy.localeCompare(b.namePy, 'zh-CN'));
  });

  // 3. 分组键按 A-Z 升序排序（仅保留一次，删除重复逻辑）
  const sortedKeys = Object.keys(grouped).sort() as Province['capitalize'][];
  const result = {} as GroupedProvinces;

  sortedKeys.forEach(key => {
    result[key] = grouped[key] as Province[];
  });

  // 唯一返回语句，函数体正确闭合
  return result;
};

</script>

<style scoped lang="scss">
.custom-area-dialog {
  // 穿透修改弹窗默认样式
  :deep(.el-dialog__body) {
    padding: 20px 0 !important;
    background: #252c3d;
  }

  .custom-wrapper {
    padding: 0 25px;
  }

  // 头部样式
  .header {
    padding: 10px 0 25px;
    cursor: default;

    .cumtom-title {
      color: #ffffff;
      font-size: 36px;
      font-weight: 600;
      line-height: 50px;
    }

    .el-icon {
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: var(--primary-color);
      }
    }
  }

  // 搜索框样式
  .custom-search {
    height: 50px;
    margin: 0 0 40px;

    :deep(.el-select__wrapper) {
      height: 100%;
      flex: 1;
      background: #3c4250;
      box-shadow: none;
      border-radius: 4px 0 0 4px;
      border: none;
      .el-select__input {
          color: #fff;
          font-size: 16px;
          padding: 0;
        }

        .el-input__placeholder {
          color: var(--gray-light);
        }
    }

    .city-search-empty {
      padding: 12px 16px;
      color: rgba(255, 255, 255, 0.6);
      font-size: 14px;
      text-align: center;
    }

    .btn-default {
      width: 50px;
      height: 50px;
      border-radius: 4px;
      font-size: 24px;
      color: #fff;
      line-height:50px;
      cursor: pointer;
      transition: background 0.3s;
      margin-left:8px;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-icon {
        width: 100%;
        text-align: center;
      }
    }
  }
  // 标题通用样式
  .h3-title {
    font-size: 24px;
    color: #fff;
    font-weight: bold;
    line-height: 36px;
    padding-bottom: var(--spacing-32);
    margin: 0;
  }

  // 热门城市样式
  .hot-city {
    margin-bottom:40px;
      .custom-tag {
        color: #fff;
        border: none;
        font-size: 16px;
        border-radius: 4px;
        transition: all 0.3s;
        display:flex;
        flex-wrap:wrap;
        div {
            padding: 8px 16px 8px 0;
            display:block;
            a{
                color:#fff;
                text-decoration: none;
                &:hover{
                    text-decoration: underline;
                }
            }
        }
    }
  }

  // 省份区域核心样式（重新排版）
  .province-section {
    .province-container {
      // 单个首字母分组
      .province-group {
        margin-bottom: 20px;
        align-items: flex-start;
        // 首字母标签
        .initial-tag {
          .initial-text {
            color: #fff;
            font-size: 16px;
            min-width: 60px;
            margin-right: 10px;
            padding-top: 2px;
          }
        }

        // 省份/城市列表：固定列宽网格，每列左对齐且不重叠
        .province-list {
          flex: 1;
          min-width: 0;
          display: grid;
          grid-template-columns: repeat(auto-fill, 128px);
          column-gap: 16px;
          row-gap: 8px;
          align-items: start;
          .province-item {
            color: #fff;
            font-size: 16px;
            width: 100%;
            min-width: 0;
            max-width: 100%;
            padding: 0;
            box-sizing: border-box;
            cursor: pointer;
            text-align: left;
            line-height: 22px;
            white-space: normal;
            word-break: keep-all;
            overflow-wrap: break-word;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }

  // 响应式适配
  @media (max-width: 768px) {
    .header .cumtom-title {
      font-size: 24px;
      line-height: 40px;
    }

    .h3-title {
      font-size: 18px;
      line-height: 30px;
      padding-bottom:20px;
    }
    .hot-city {
        margin-bottom:20px;
    }

    .province-section {
      .province-container {
        .province-group {
          flex-direction: column;
          gap: 8px;
          .initial-tag {
            .initial-text {
              min-width: 0;
              margin-right: 0;
            }
          }
          .province-list {
            width: 100%;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            column-gap: 12px;
            row-gap: 6px;
          }
        }
      }
    }
    .province-item {
      font-size: 14px !important;
      padding: 0 !important;
    }
    .custom-wrapper {
       padding: 0 10px;
    }
     .custom-search {
        height: 40px;
        margin: 0 0 20px;
        .btn-default {
            width: 40px;
            height: 40px;
            line-height:40px;
            font-size:20px;
         }
     }
  }
}
</style>

<!-- el-dialog 需全局样式才能稳定命中（同 popUp.vue） -->
<style lang="scss">
@media (max-width: 499.98px) {
  .custom-area-dialog.el-dialog {
    height: 500px;
    max-height: 500px;
    display: flex;
    flex-direction: column;
    margin: 15vh auto 0;

    .el-dialog__body {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
    }
  }
}
</style>